import PropTypes from 'prop-types';
import { switchButtonStyle } from '../../utilities/Usuarios/switchButtonStyle';

export const UserActive = ({ onSwitchStateChange, activo }) => {
    return (
        <div className="col-12 col-sm-6 mt-2">
            <div className="form-group">
                <p className="control-label font-weight-bold d-block mb-2 text-muted text-uppercase small" style={{ letterSpacing: '1px', fontWeight: "600" }}>Usuario Activo</p>
                <button
                    type="button"
                    onClick={onSwitchStateChange}
                    style={switchButtonStyle(activo, false)}
                    className="d-flex align-items-center justify-content-center shadow-sm"
                >
                    <i className={`mdi ${activo ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline'} me-2`} style={{ fontSize: '1.2rem' }}></i>
                    <span>{activo ? "ACTIVO" : "INACTIVO"}</span>
                </button>
            </div>
        </div>
    );
}
UserActive.propTypes = {
    onSwitchStateChange: PropTypes.func,
    activo: PropTypes.bool
}